if (!customElements.get('free-product')) {
  customElements.define(
    'free-product',
    class FreeProduct extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();

        // this.quantityInput = this.querySelector('.quantity__input');
        // this.submitButton = this.querySelector('.free-pro-btn');
        // this.submitButtonText = this.submitButton.querySelector('span');
        this.freeProduct = this.querySelectorAll('.free-product-option');
        this.allAvailable = true; // reset before loop
        this.allMatched = true;    // track if all variants matched

        
        this.form = this.querySelector('form');
        // this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        // ✅ Close button handler Free Product Popup
        const closeBtn = document.querySelector('.free_product_popup_container .free_product_modal_close');
        if (closeBtn) {
          closeBtn.addEventListener('click', this.togglePopup.bind(this, 'remove'));
        }

        // Bind event listener when class is created
        document.addEventListener('product:added', (event) => {
          this.checkFreeProInCart(event);
        });
      }

      connectedCallback() {
        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        // this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      // Fetch cart JSON
      async getCartJSON() {
        try {
          const response = await fetch('/cart.js'); // Shopify AJAX cart API
          const cartData = await response.json();
          return cartData;
        } catch (error) {
          console.error('Error fetching cart data:', error);
        }
      }

      // Check cart and open popup if free product not added
      async checkFreeProInCart(data) {
        const cart = await this.getCartJSON();

        if (window.free_product != null) {
          let freeProductHandle = window.free_product.handle;

          const matchingItem = cart.items.find(
            (item) => item.handle === freeProductHandle
          );

          if (matchingItem) {
            // console.warn('Free product already in cart:', matchingItem);
          } else {
            // console.warn('Free product not found in the cart. Opening popup...');
            this.togglePopup('add');
          }
        }
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;

        this.initializeFitPredictor();
        this.initializeFitSizes();

        // ⚡ Reset flags for this selection
        this.allAvailable = true;
        this.allMatched = true;

        this.freeProduct.forEach((bundleItem, index) => {
            // STEP 2: get all selected values
            let selectedOptions = Array.from(bundleItem.querySelectorAll('input[type="radio"]:checked'))
                                      .map(el => el.value);

            // STEP 3: get full product JSON
            let productJsonEl = bundleItem.querySelector('script[data-product-json]');
            if (!productJsonEl) {
                // console.warn('❌ No product JSON found for this bundle item');
                this.allMatched = false;
                return;
            }
            let productData = JSON.parse(productJsonEl.textContent);

            // STEP 4: find the matching variant
            let matchedVariant = productData.variants.find(v =>
                JSON.stringify(v.options) === JSON.stringify(selectedOptions)
            );

            if (!matchedVariant) {
                // console.warn('⚠️ No matching variant for options', selectedOptions);
                this.allMatched = false;
                return;
            }

            // Update selected variant
            let variantInput = bundleItem.querySelector('[name="variant id"]');
            if(variantInput){
              variantInput.value = matchedVariant.id;
            }

            // STEP 5: update image
            if (matchedVariant.featured_image && matchedVariant.featured_image.src) {
                let imgEl = bundleItem.querySelector('.free_pro_image img');
                if (imgEl) {
                    imgEl.src = matchedVariant.featured_image.src;
                    imgEl.srcset = `${matchedVariant.featured_image.src}&width=200 200w, ${matchedVariant.featured_image.src}&width=400 400w`;
                }
            }

            // STEP 6: update selected variant
            let selectedVariantEl = bundleItem.querySelector('script[data-selected-variant]');
            if (selectedVariantEl) {
                selectedVariantEl.textContent = JSON.stringify(matchedVariant);
                // console.log('✅ Updated selected variant:', matchedVariant);

                if (!matchedVariant.available) {
                    this.allAvailable = false;
                }
            } else {
                this.allMatched = false;
            }
            // console.log(selectedVariantEl, "selectedVariantEl");

        });

        // Disabled solout variant and unavailable variant start
        const optionGroups = Array.from(target.closest('variant-selects').querySelectorAll('fieldset'));
        
        // Build current selection array
        const selectedOptions = optionGroups.map(group => {
          const checked = group.querySelector('input[type="radio"]:checked');
          return checked ? checked.value : null;
        });

        // STEP 3: get full product JSON
        let productJsonEl = target.closest('.free-product-option').querySelector('script[data-product-json]');
        if (!productJsonEl) {
            return;
        }
        let productData = JSON.parse(productJsonEl.textContent);

        optionGroups.forEach((group, groupIndex) => {
          group.querySelectorAll('input[type="radio"]').forEach(input => {
            const tempSelected = [...selectedOptions];
            tempSelected[groupIndex] = input.value; // try this input in current selection

            // Check if a variant matches this combination
            const match = productData.variants.find(v =>
              JSON.stringify(v.options) === JSON.stringify(tempSelected)
            );

            if (!match || !match.available) {
              input.classList.add('disabled');
            } else {
              input.classList.remove('disabled');
            }
          });
        });
        // Disabled solout variant and unavailable variant End

        // ---- Submit button Enable Disabled ----
        if (!this.allMatched) {
            this.toggleSubmitButton(true, window.variantStrings.unavailable);
        } else if (!this.allAvailable) {
            this.toggleSubmitButton(true, window.variantStrings.soldOut);
        } else {
            this.toggleSubmitButton(false);
        }

      }

      // Runs Small Start
      initializeFitPredictor() {
        document.addEventListener('click', function (e) {
          const radio = e.target.closest('.size-variant-option [type="radio"]');
          if (!radio) return;

          const productInfo = radio.closest('.product-info');
          if (!productInfo) return;

          const wrappers = {
            small: productInfo?.querySelector('.runs-small-wrapper'),
            big: productInfo?.querySelector('.runs-big-wrapper')
          };

          // Get the JSON data inside the same free-product-option
          const fitDataEl = productInfo?.querySelector('.fit-predictor-json'); 
          const fitData = fitDataEl ? JSON.parse(fitDataEl.textContent) : { runSmall: [], runBig: [] };

          // Example: toggle hidden classes
          if (wrappers.small)
            wrappers.small.classList.toggle('hidden', !(fitData.runSmall || []).includes(radio.value));
          if (wrappers.big)
            wrappers.big.classList.toggle('hidden', !(fitData.runBig || []).includes(radio.value));
        });
      }
      // Runs Small End

      // Fit Sizes Start
      initializeFitSizes() {
        document.addEventListener('click', function (e) {
          const radio = e.target.closest('.size-variant-option [type="radio"]');
          if (!radio) return;

          const productInfo = radio.closest('.product-info');
          if (!productInfo) return;

          const fitSizesEl = productInfo.querySelector('.fit_sizes_data');
          const fitSizesBox = productInfo.querySelector('.fit_sizes');
          const fitSizeContent = productInfo.querySelector('.fit_size_content');

          if (!fitSizesEl || !fitSizesBox || !fitSizeContent) {
            console.warn('[Fit Sizes] Scoped elements not found in product-info.');
            return;
          }

          let fitSizesData;
          try {
            fitSizesData = JSON.parse(fitSizesEl.textContent);
          } catch (err) {
            console.error('[Fit Sizes] JSON parse error:', err);
            return;
          }

          const selectedSize = radio.value.replaceAll('-', '/');
          const matchedSize = fitSizesData.find(item => item.size === selectedSize);

          if (matchedSize) {
            fitSizeContent.innerHTML = matchedSize.size_content;
            fitSizesBox.classList.remove('hidden');
          } else {
            fitSizeContent.innerHTML = '';
            fitSizesBox.classList.add('hidden');
          }
        });
      }
      // Fit Sizes End

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.freetoCart;
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        config.headers['Content-Type'] = 'application/json'; // JSON payload

        this.allProduct = document.querySelectorAll('.free-product-option');

        // 🔥 Collect all variant IDs from bundle products
        let items = [];
        this.allProduct.forEach(bundleItem => {
          let variantInput = bundleItem.querySelector('[name="variant id"]');
          if (!variantInput) return;


          let variant_id = parseInt(variantInput.value);
          if (!variant_id) return;

          let free_pro_handles = variantInput.dataset.handles;
          let mm = parseInt(variantInput.dataset.mm);
          let ss = parseInt(variantInput.dataset.ss);
          let timer = variantInput.dataset.timer;

          items.push({
            id: variant_id,
            quantity: 1,
            properties: {
              _free_pro_handles: free_pro_handles,
              _free_pro_mm: mm,
              _free_pro_ss: ss,
              _free_pro_timer: timer,
            },
          });
        });

        // Build body for cart/add.js
        let formData = {
          items: items
        };

        if (this.cart) {
          formData.sections = this.cart.getSectionsToRender().map((section) => section.id);
          formData.sections_url = window.location.pathname;
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = JSON.stringify(formData); // ✅ FIXED

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            document.dispatchEvent(
              new CustomEvent('product:added', { detail: { product: response }, bubbles: true })
            );

            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                cartData: response,
              });
            }

            this.error = false;
            this.cart.renderContents(response);

            this.togglePopup('remove');
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      // ✅ Close or Open the pop for Free Product
      togglePopup(action = 'remove') {
        const el = document.querySelector('.free_product_popup_container');
        if (!el) return;

        el.classList[action]('open'); 
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

    }
);
}

